import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import { productName } from '@/constants/env';

/**
 * TDA: the brand name shown on the sign-in pages.
 *
 * The name set in Console > Sign-in experience > Branding wins over the
 * build-time product name.
 */
const useBrandName = () => {
  const { experienceSettings } = useContext(PageContext);

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- an empty or whitespace-only name must fall back to the product name, which `??` would not do
  return experienceSettings?.branding.name?.trim() || productName;
};

export default useBrandName;
